// extracted by mini-css-extract-plugin
module.exports = {"select":"style_select__oX7wU"};